import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = '100%' }) => {
  return (
    <svg width={width} height={height} x="0px" y="0px" viewBox="0 0 64 64" fill="currentColor" stroke="currentColor">
      <g>
        <defs>
          <polygon points="-507,-1597.791 -508.209,-1599 -513,-1594.209 -517.791,-1599 -519,-1597.791 -514.209,-1593 -519,-1588.209 -517.791,-1587 -513,-1591.791 -508.209,-1587 -507,-1588.209 -511.791,-1593 		"></polygon>
        </defs>
        <g>
          <defs>
            <rect x="-688" y="-3317" width="1440" height="6698"></rect>
          </defs>
        </g>
      </g>
      <line
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="none"
        stroke-width="6"
        stroke-linecap="round"
        stroke-linejoin="round"
        x1="8.388"
        y1="54.345"
        x2="55.207"
        y2="7.526"></line>
      <line
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="none"
        stroke-width="6"
        stroke-linecap="round"
        stroke-linejoin="round"
        x1="8.388"
        y1="7.526"
        x2="55.207"
        y2="54.345"></line>
    </svg>
  );
};

export default Icon;
